import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import uk from './data/localization/uk.json';
import en from './data/localization/en.json';
import ger from './data/localization/ger.json';
import fr from './data/localization/fr.json';

import { store } from './redux/store';

const currentLang = store.getState().language.lang;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    uk: { translation: uk },
    ger: { translation: ger },
    fr: { translation: fr }
  },
  lng: currentLang, // default language
  fallbackLng: 'uk',
  interpolation: {
    escapeValue: false
  }
});

store.subscribe(() => {
  const currentLanguage = store.getState().language.lang;
  if (i18n.language !== currentLanguage) {
    i18n.changeLanguage(currentLanguage);
  }
});

export default i18n;
